import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// action creators
import { membershipConcernDelete } from '../../../../actions/membershipConcernActions';

// components
import ConcernsTab from './ConcernsTab';
import getMembershipConcerns from '../../../../lib/selectors/getMembershipConcerns';
import getLoadingFromState from '../../../../lib/selectors/getLoadingFromState';

const mapStateToProps = (state, { pnmId }) => ({
  currentChapter:     state.get('currentChapter'),
  membershipConcerns: getMembershipConcerns(pnmId)(state),
  concernsLoading:    getLoadingFromState('membershipConcern')(state),
});

const mapDispatchToProps = dispatch => ({
  deleteMembershipConcern: (params) => {
    dispatch(membershipConcernDelete(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConcernsTab));
